<template>
    <div class="doctor-component">
        <DoctorFormComponent :button-titles="buttonTitles" :prescriber-id="prescriberId" />
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import DoctorFormComponent from '@/components/Doctor/DoctorFormComponent.vue';
import { ButtonTitles } from "@/components/ButtonTitles";

@Component({
    name: "DoctorDetailsPage",
    components: { DoctorFormComponent },
})

export default class DoctorDetailsPage extends Vue {
    protected get buttonTitles(): ButtonTitles {
        if (!this.prescriberId) {
            return {
                new: "New Doctor",
                clear: "Clear",
                save: "Save Changes",
                cancel: "",
            };
        }
        return {
            new: "",
            clear: "Clear",
            save: "Save Changes",
            cancel: "",
        };
    }

    get prescriberId(): number | undefined {
        const id = this.$route.params.id;
        if (id) {
            const parsed = parseInt(id);
            return isNaN(parsed) ? undefined : parsed;
        }
        return undefined;
    }

    created() {
        console.log("%c Created DoctorDetailsPage", "color: green");
    }

    beforeDestroy() {
        console.log('%c Destroying DoctorDetailsPage', 'color: red');
    }
}
</script>

<style scoped>
</style>
